import React from 'react';


const TemplateLoader = () => {
  return (
    <div className="ui basic segment" style={{ height: 50 }}>
      <div className="ui active small indeterminate loader"></div>
    </div>
  );
}


export default TemplateLoader;
